<template>
  	<div class="article-allsee">
		<div class="title">
			<span>
				<em class="ln"></em>
				大家都在看
			</span>
		</div>
		<div class="allsee-list clear" id="allseeList" data-spm="fd-link">
			<template v-for="(item,index) in items" >
				<div 
					:key="index" 
					v-if="!item.adType"
					data-role="allsee-item" 
					class="allsee-item clear" 
					:data-newsid="item.position" 
					:data-media-id="item.authorId"
					:data-loc="index" 
					:data-cate-id="item.cate_id" 
					:data-tag-id="item.tag_id"
					:data-position="index" 
					data-spm-type='resource'
				>
					<a class="allsee-image img-do" :href="item.url" target="_blank" data-spm-type="content">
						<img :data-src="item.image" :src="preloadUrl"/>
					</a>
					<a class="allsee-title" :href="item.url" target="_blank">
						{{item.title}}
					</a>
				</div>
				<!-- 广告 -->
				<div v-else :key="index" class="allsee-item clear bd-wrap" :id="item.randomId">
					
				</div>
			</template>
		</div>
	</div>
</template>

<script>
import spmUtils from "../utils/spm_utils"
import GetAsspAd from "@/components/adver/index"
import { setPicSize } from "../utils/pic-util"
import { acodeConfig } from '../config/spmConfig'
import { getOdinResourceIdMap,nullResourceId } from '@/config/odinResourceIds'
import { getOdinData,formatOdinData } from "@/request/odinRequest"

var odinStateCodeMap = {
    SUCCESS: "SUCCESS",
    EMPTY: "EMPTY",
    TIMEOUT: "TIMEOUT",
    ERROR: "ERROR",
}

export default {
	name: "allSeeList",
	data() {
		return {
			sGrade: '',
			items: '',
			sceneId: '',
			resourceId: '',
            senceKey: '',
            idsMap: {},
			news_id: window?.pcArticleInfo?.news_id,
			subid: '',
			channel_id: window?.pcArticleInfo?.channel_id,
			media_id: window?.pcArticleInfo?.media_id,
			contentArr: [],
			adArr: [],
            preloadUrl: "//statics.itc.cn/web/static/images/pic/preload.png",
		}
	},
	mounted() {
        this.senceKey = 'allSeeArticle'
        this.idsMap = getOdinResourceIdMap(this.senceKey)
		this.sGrade = window?.pcArticleInfo?.sGrade
		this.resourceId = this.sGrade == 0 ? this.idsMap?.resourceId: nullResourceId

		this.fetchData()
	},
	methods: {
		async fetchData() {
            const spmObj = window?.sohuSpm?.getCodes()
            const param = {
                tplCompKey: this.senceKey,
                adInfo: this.sGrade == 0 ? this.idsMap?.adInfo : {},
                spmCCode: this.idsMap?.spmCCode,
                resourceId: this.resourceId,
                content: {
                    page: 1,
                    size: 9,
                    productId: this.idsMap?.productId,
                    productType: this.idsMap?.productType,
                    spm: `${spmObj?.a}.${spmObj?.b}.${this.idsMap?.spmCCode}`
                },
                context:{
                    mkey:`channelId_${this.channel_id}--mpid_${this.news_id}`
                }
            }
			let reportInfo = this.getReportInfo(param) || []
			let adLocations = []
			// 广告请求上报
			if (this.sGrade != 0) {
				spmUtils.sendAction(acodeConfig.adRequest, reportInfo.join(';'))
			}
            try {
                let res = await getOdinData(param)
                if(res?.list?.length) {
                    let list = formatOdinData(res)
                    reportInfo.push('code:' + odinStateCodeMap.SUCCESS)
					list.forEach((i,o)=>{
						if(i.resourceType == 3) {
							adLocations.push(o + 1)
						}
						if (i.adType) {
						    this.adArr.push(i)
						}else {
                            const ratio = 2
                            const coverWidth = 195 * ratio
                            const coverHeight = 130 * ratio
                            i.image = setPicSize(i.images?.[0],coverWidth,coverHeight)
                        }
					})
					this.items = list
					// 渲染广告
					setTimeout(()=>{
                        window?.LazyLoadIns?.scanImg()
						this.renderAd(this.adArr);
                        window.sohuSpm?.domDidChange({target: 'fd-link'});
					})
                }else {
                    reportInfo.push('code:' + odinStateCodeMap.EMPTY)
                }
            } catch (error) {
                console.log('大家都在看广告error',error)
                reportInfo.push('code:' + odinStateCodeMap.ERROR)
                spmUtils.sendAction(acodeConfig.adRequestComplete, reportInfo.join(';'))
            }
        },
		renderAd(data) {
			const resourceId = this.resourceId
			data.forEach(function(item) {
				var loc = item.position + 1; // 在对应位置插入广告
				item.spmLoc = 'fd-link.' + loc

				GetAsspAd({
					data: item,
					el: document.getElementById(item.randomId),
					spmCode: item.spmLoc,
					resourceId: resourceId
				})
			})
		},
		// 获取上报信息
		getReportInfo(resourceParam){
			var resourceId = resourceParam.resourceId
			var reportInfo = []
			reportInfo.push('resourceId:'+ resourceId)
			reportInfo.push('location:'+ resourceParam.content.spm)
			if(resourceParam.content.page){
				reportInfo.push('pg:'+ resourceParam.content.page)
			}
			if(resourceParam.content.size){
				reportInfo.push('sz:'+ resourceParam.content.size)
			}
			return reportInfo
		}
	}
}
</script>

<style lang="less">
.article-allsee {
    box-sizing: border-box;
    padding-top: 15px;
    .title {
        height:19px;
        span {
            float:left;
            line-height:1;
            font-size:18px;
            color:#191919;
        }
        .ln{
            float:left;
            margin-right:12px;
            width:4px;
            height:19px;
            border-radius:2px;
            background:#fdd000;
        }
    }
    .allsee-list {
        width: 680px;
        padding-top: 13px;
    }
    .allsee-item {
        float:left;
        margin-right: 27px;
        margin-bottom: 16px;
        width:195px;
        height: 178px;
        position: relative;
        .allsee-image{
            display: block;
            height:130px;
            img{
                width:100%;
                height:100%;
            }
        }
        .allsee-title{
            display: block;
            display: -webkit-box;
            overflow:hidden;
            margin-top:8px;
            width:100%;
            height:40px;
            line-height:20px;
            font-size:14px;
            color:#303030;
            -webkit-line-clamp: 2;
            word-break: break-all;
            -webkit-box-orient: vertical;
            &:hover {
                color: #E63939;
            }
        }
        .allsee-ad-icon {
            display: block;
            position: absolute;
            width: 17px;
            top: 115px;
            height: 15px;
            right: 26px;
            font-size: 0;
            background-color: rgba(0, 0, 0, 0.5);
            .see-i-icon {
                cursor: pointer;
                position: absolute;
                height: 15px;
                width: 15px;
                display: inline-block;
                background: url(../images/ad-icon.png) no-repeat 3px 2px;
                background-size: 11px 11px;
                z-index: 2;
            }
        }
        .adver-i-tag {
            position: absolute;
            bottom: 48px;
            right: 0;
            display: inline-block;
            width: 26px;
            margin-left: 16px;
            height: 15px;
            line-height: 16px;
            background-color: rgba(0, 0, 0, 0.5);
            color: #DDDDDD;
            font-size: 12px;
        }
    }
}
</style>
